export default "__VITE_ASSET__CYHhuhOi__"